import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexSelectionProcessObservationsRequest = (
  selectionProcessId,
  selectionProcessCandidateId,
  { dispatch, params, successCallback, failureCallback, callback }
) =>
  ApiService.request(
    'get',
    `/selection_processes/${selectionProcessId}/selection_process_candidates/${selectionProcessCandidateId}/observations`,
    {
      dispatch,
      params,
      successCallback,
      failureCallback,
      callback
    }
  );

export const createSelectionProcessObservationRequest = (
  selectionProcessId,
  selectionProcessCandidateId,
  { dispatch, params, successCallback, failureCallback, callback }
) =>
  ApiService.request(
    'post',
    `/selection_processes/${selectionProcessId}/selection_process_candidates/${selectionProcessCandidateId}/observations`,
    {
      dispatch,
      params,
      successCallback,
      failureCallback,
      callback
    }
  );

export const debounceIndexSelectionProcessObservationsRequest = AwesomeDebouncePromise(
  indexSelectionProcessObservationsRequest,
  300
);
